import React from 'react';
import { Typography, IconButton, makeStyles } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';
import { COLORS } from './logsConstants';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 24px',
    borderBottom: `1px solid ${COLORS.border}`,
  },
  title: {
    fontSize: 19,
    fontWeight: 700,
    color: COLORS.textPrimary,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  iconBtn: {
    padding: 6,
    color: COLORS.textSecondary,
    '&:hover': { color: COLORS.textPrimary },
  },
}));

export default function LogsHeader({ onClose }) {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <Typography className={classes.title}>Logs</Typography>
      <div className={classes.headerActions}>
        
        {/* <IconButton className={classes.iconBtn} aria-label="Help">
          <HelpOutlineIcon style={{ fontSize: 18 }} />
        </IconButton> */}
        <IconButton className={classes.iconBtn} id="close-logs-modal" onClick={onClose} aria-label="Close">
          <RemoveIcon style={{ fontSize: 18 }} />
        </IconButton>
      </div>
    </div>
  );
}